import styled from 'styled-components';

import { Typography } from '@/components/ui/Typography/Typography.styles';
import { flexCenterAligned } from '@/styles/common';

export const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  ${flexCenterAligned};
  flex-direction: column;
  color: var(--textAndLabels-main);
`;

export const TextWrapper = styled.div`
  margin-top: 30px;
  flex-direction: column;
  gap: 10px;
  ${flexCenterAligned};
`;

export const Description = styled(Typography).attrs({ variant: 'body3' })`
  color: var(--textAndLabels-secondary);
  text-align: center;
`;
